import { render, staticRenderFns } from "./download_1.vue?vue&type=template&id=3c18be59&scoped=true&"
var script = {}
import style0 from "./download_1.vue?vue&type=style&index=0&id=3c18be59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18be59",
  null
  
)

export default component.exports